import { CreateCartelQueueAIParams, CreateCartelRemixQueueAIParams } from "../types/requestInputs";
import { CreateCartelQueueAIResponse } from "../types/requestsOutputs";
import { fetchAPI } from "./utils";

export const createCartelQueueAI = async ({
    token,
    isFromDb,
    dbSourceId,
    language,
    textObject,
    numberOfWords,
    audience,
    textTitle,
    numberStories,
    requiredContent,
    queryFilters,
    restrictToDatabase,
    brandVoiceId,
    audienceProfileId,
}: CreateCartelQueueAIParams): Promise<CreateCartelQueueAIResponse> => {
    return fetchAPI<CreateCartelQueueAIResponse>(
        "/add-one-text-cartel-item-queue",
        "POST",
        {
            isFromDb,
            dbSourceId,
            language,
            textObject,
            numberOfWords,
            audience,
            textTitle,
            numberStories,
            requiredContent,
            queryFilters,
            restrictToDatabase,
            brandVoiceId: brandVoiceId || null,
            audienceProfileId: audienceProfileId || null,
        },
        token,
    );
};

export const createCartelRemixQueueAI = async ({
    token,
    language,
    textObject,
    textTitle,
    remixPrompt,
}: CreateCartelRemixQueueAIParams): Promise<CreateCartelQueueAIResponse> => {
    return fetchAPI<CreateCartelQueueAIResponse>(
        "/add-one-cartel-remix-item-queue",
        "POST",
        {
            language,
            textObject,
            textTitle,
            remixPrompt,
        },
        token,
    );
};
